import { render, staticRenderFns } from "./ModalWithButton.vue?vue&type=template&id=4fd972a8"
import script from "./ModalWithButton.vue?vue&type=script&lang=js"
export * from "./ModalWithButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports